import { UntypedFormControl } from '@angular/forms';

export default function conditionalValidator(predicate, validator) {
    return (formControl: UntypedFormControl) => {
        if (!formControl.parent) {
            return null;
        }
        if (predicate()) {
            return validator(formControl);
        }

        return null;
    };
}
